import config from "../config.json";

// Determine if we're in development mode
const isDevelopment = process.env.NODE_ENV === 'development';

// Use proxy path in development, full URL in production
export const API_BASE_URL = isDevelopment 
  ? '/prod'  // This will be proxied to the full URL
  : config.API_BASE_URL;

export const getApiUrl = () => API_BASE_URL;